import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getOil } from "utils/LaravelApi/LaravelAPI";
import WebViewOil from "./WebViewOil";

export default function OilProduct() {

   const { type, brand, characteristic, unit } = useParams();
   const [data, setData] = useState({
      id: 0,
      price: 0,
      discount: true,
      discountPrice: 0,
      discountPercentage: 10,
      name: "",
      disableOil: true,
      liters: null,
      description: "",
   });
   const [dataURL, setDataURL] = useState([]);

   useEffect(() => {

      const fetchOilProduct = async () => {
         const oil = await getOil(type, brand, characteristic, unit);
         if (oil.success) {
            setData(oil.data);
            setDataURL(oil.data.pictures);
         }
      };
      fetchOilProduct();
   }, [type, brand, characteristic, unit]);

   return (
      <div>
         <WebViewOil data={data} dataURL={dataURL} />
      </div>
   );
}